export default __webpack_public_path__ + "static/media/logo (1).c91622f1.png";